import {
  Fan,
  AirVent,
  Boxes,
  Server,
  Flame,
  Zap,
  PencilRuler,
} from "lucide-react";

const MAP = { Fan, AirVent, Boxes, Server, Flame, Zap, PencilRuler };

// Резолвит имя иконки из data/services.js в компонент lucide-react.
export default function ServiceIcon({ name, ...props }) {
  const Cmp = MAP[name] || Boxes;
  return <Cmp {...props} />;
}
